// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"54bc7ef0","466":"55a30424","738":"31fd7fdc","787":"21e6e165","856":"a442bff8","858":"33fea034"}[chunkId] + ".chunk.js";
};